import * as React from 'react';
import { SiteVariablesPrepared } from "@fluentui/react-northstar";
import { IChartData } from "../chart-types";
import LineChart from "../charts/line";

export const LineAreaChart = ({
    title,
    data,
    siteVariables,
}: {
    title: string;
    data: IChartData;
    siteVariables: SiteVariablesPrepared;
}) => (
    <LineChart
        {...{
            title,
            data,
            siteVariables,
            gradients: true,
        }}
    />
);
